export default __webpack_public_path__ + "static/media/Bees-Regular.94a1bb8d.ttf";